/** EmptyState — no-results / nothing-here placeholder, with an optional action. */
export function EmptyState({ title, description, action }) {
  const el = document.createElement("div");
  el.className = "empty-state";

  const heading = document.createElement("div");
  heading.className = "empty-state-title";
  heading.textContent = title;
  el.append(heading);

  if (description) {
    const p = document.createElement("p");
    p.className = "hint";
    p.textContent = description;
    el.append(p);
  }

  if (action) el.append(action);
  return el;
}
